import React, { Component } from "react";
import { Segment, Grid, Checkbox, Container, Button } from "semantic-ui-react";
import Terms from "./terms/Terms";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { Config } from "../../../data/config";
import { getUrlParameters } from "../../../util";

const initialState = {
  visibleItems: true,
  visibleTerms: false,
  visibleForm: false,
  visibleMessage: false,
  disableButton: true,
  isConnecting: false,
  connectError: null
};

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;
    this.onClickTerms = this.onClickTerms.bind(this);
    this.onClickReturn = this.onClickReturn.bind(this);
    this.connectNow = this.connectNow.bind(this);
  }
  componentDidMount() {
    document.querySelector("body").classList.add("bg--black");
  }

  componentWillUnmount() {
    document.querySelector("body").classList.remove("bg--black");
  }

  onClickTerms() {
    this.setState({
      visibleTerms: true,
      visibleItems: false
    });
  }

  onClickReturn() {
    const newState = { ...initialState };
    this.setState(newState);
  }

  handleCheck = (e, { checked }) => {
    if (!checked) {
      this.setState({
        disableButton: true
      });
    } else {
      this.setState({
        disableButton: false
      });
    }
  };

  connectNow() {
    this.setState({ isConnecting: true, connectError: null });
    axios
      .post(`${Config.apiUrl}/wifi/auth`, { mac: this.getMACAddress(), ap: this.getAPAddress() })
      .then(response => {
        this.redirectToGuestHotspotSuccess();
      })
      .catch(error => {
        const errorMessage = this.getErrorMessage(error);
        this.setState({ isConnecting: false, connectError: errorMessage });
      });
  }

  redirectToGuestHotspotSuccess() {
    window.location.replace('/hotspot/success/guest');
  }

  getErrorMessage(error) {
    let errorMessage = "";
    if (typeof(error.response) === 'undefined') {
      errorMessage = "An unknown issue occurred. Please try again."
    } else if (error.response.status === 422) {
      const errors = error.response.data.error.errors;
      Object.keys(errors).forEach(err => {
        errorMessage += `${errors[err][0]}\n`;
      });
    } else {
      errorMessage =
        (error.response.data.error && error.response.data.error.message) ||
        "Something went wrong";
    }
    return errorMessage;
  }

  getMACAddress() {
    const queryString = this.props.location.search;
    if (queryString) {
      const params = getUrlParameters();
      return params['id'] || null
    }
    return null;
  }

  getAPAddress() {
    const queryString = this.props.location.search;
    if (queryString) {
      const params = getUrlParameters();
      return (params["ap"] === 'unknown' ? null : params["ap"]) || null;
    }
    return null;
  }

  render() {
    const {
      visibleTerms,
      visibleForm,
      visibleItems,
      visibleMessage,
      disableButton,
      isConnecting,
      connectError
    } = this.state;

    return (
      <Segment className="py-0 hotspot" inverted vertical>
        {visibleForm && (
          <div className="back--icon" onClick={this.onClickReturn} />
        )}
        {visibleMessage && (
          <div className="close--icon" onClick={this.onClickReturn} />
        )}

        <Container className="space-h">
          {!visibleMessage && (
            <Grid verticalAlign="middle" stackable className="height--100vh">
              <Grid.Row columns={2}>
                <Grid.Column className="text-xs-center">
                  <h1 className="no-decoration text-prime itc-mdbold main-logo cursor-pointer">
                    Fibre
                    <span className="normal text-white itc-bk">Stream</span>
                  </h1>
                  <p className="desc mt-4 text-grey3">
                    Enjoy Free Wi-Fi from FibreStream
                  </p>
                </Grid.Column>
                {visibleItems && (
                  <Grid.Column className="block__items">
                    <Checkbox
                      onChange={this.handleCheck}
                      className="mb-3"
                      label={
                        <label className="text-grey3">
                          {" "}
                          I accept the{" "}
                          <span onClick={this.onClickTerms}>
                            <u>terms of use</u>
                          </span>
                        </label>
                      }
                    />
                    <div className="sixteen wide tablet seven wide computer column right floated">
                      <div className="ui items unstackable">
                        <div className={"item ui segment no-decoration"}>
                          <div className="item__heading">Connect Now</div>
                          <div className="item__time text-grey3">12 hours</div>
                          <div className="ui column vertical ui segment right aligned py-0">
                            <Button
                              className="ui button prime medium"
                              disabled={disableButton ? true : false}
                              onClick={this.connectNow}
                            >
                              {isConnecting ? "Connecting ..." : "Connect"}
                            </Button>
                          </div>
                          {connectError && (
                            <div className="error-text mt-2">{connectError}</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </Grid.Column>
                )}
                {visibleTerms && (
                  <Terms
                    onClickReturn={this.onClickReturn}
                    visibleTerms={visibleTerms}
                  />
                )}
              </Grid.Row>
            </Grid>
          )}
        </Container>
      </Segment>
    );
  }
}

export default withRouter(Home);



// WEBPACK FOOTER //
// ./src/components/hotspot/home/Home.js